import React, { useState } from "react";
import {
  Container,
  Card,
  Stack,
  Text,
  Button,
  Title,
  Group,
  Alert,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { IconDownload, IconFileZip, IconAlertCircle } from "@tabler/icons-react";
import { notifications } from "@mantine/notifications";
import { downloadInvoiceReport } from "../misc/api";

const AdminReportScreen = () => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    if (!startDate || !endDate) {
      notifications.show({
        title: "Error",
        message: "Please select both start and end dates",
        color: "red",
      });
      return;
    }

    if (startDate > endDate) {
      notifications.show({
        title: "Error",
        message: "Start date cannot be after end date",
        color: "red",
      });
      return;
    }

    try {
      setLoading(true);
      const start = startDate.toISOString().split("T")[0];
      const end = endDate.toISOString().split("T")[0];
      await downloadInvoiceReport(start, end);
      notifications.show({
        title: "Success",
        message: "Invoice report downloaded",
        color: "green",
      });
    } catch (error) {
      notifications.show({
        title: "Error",
        message: error.message || "Failed to download report",
        color: "red",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container size="md" py="xl">
      <Stack gap="lg">
        <Title>Invoice Reports</Title>
        <Text c="dimmed">
          Select a time period to generate and download all invoice PDFs as a
          ZIP file.
        </Text>

        <Card withBorder padding="lg">
          <Stack gap="md">
            <Group grow>
              <DatePickerInput
                label="Start Date"
                placeholder="Select start date"
                value={startDate}
                onChange={setStartDate}
                clearable
                maxDate={endDate || undefined}
              />
              <DatePickerInput
                label="End Date"
                placeholder="Select end date"
                value={endDate}
                onChange={setEndDate}
                clearable
                minDate={startDate || undefined}
              />
            </Group>

            <Alert
              icon={<IconFileZip size="1rem" />}
              color="blue"
              variant="light"
            >
              This will generate a PDF for each completed transaction in the
              selected period and bundle them into a single ZIP file for
              download.
            </Alert>

            <Button
              leftSection={<IconDownload size="1rem" />}
              onClick={handleDownload}
              loading={loading}
              disabled={!startDate || !endDate}
              size="md"
            >
              Download Invoice ZIP
            </Button>
          </Stack>
        </Card>
      </Stack>
    </Container>
  );
};

export default AdminReportScreen;
